import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { Snippet } from '@white-nl/instantsearch-components';
import { Picture } from '../../../ui/Picture';

export default function Hit({
  hit,
  additionalData,
}) {
  const {
    title,
    url,
    image,
    section,
  } = hit;

  const { search } = additionalData.translates;

  return (
    <div className="col-12">
      <a href={url} className="d-block text-body">
        <div className="p-4 bg-gray-400 rounded d-flex flex-column flex-md-row justify-content-between">
          <div className="pe-md-3 pe-lg-5 pb-3 pb-md-0">
            <span className="badge text-bg-primary">{Craft.t(search, section.handle)}</span>
            {/* eslint-disable-next-line react/no-danger */ }
            <h3 className="mb-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
            <Snippet
              hit={hit}
              attribute="content"
              classNames={{ root: 'text' }}
            />
            <div className="text-small text-gray-600 mt-3">{url}</div>
          </div>
          { image && (
            <div className="">
              <Picture image={image[0]} defaultTransform="xl-min" loading="lazy" classes="w-full" />
            </div>
          ) }
        </div>
      </a>
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    section: PropTypes.objectOf(PropTypes.any),
    image: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
    })),
  }),
  additionalData: PropTypes.objectOf(PropTypes.any),
};
